"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogImage = isCatalogImage;
/**
 * Catalogue images: the pictures a template, slide or sticker from the
 * canvas dock brings along. They are part of the catalogue, not files of the
 * doc, so search, image reading and the files database leave them out.
 *
 * The insert records the blob it placed as `catalogSourceId`. While the image
 * still shows that blob it is catalogue art; once someone swaps in their own
 * picture, `sourceId` differs and the image is content again.
 */
function isCatalogImage(props) {
    const { catalogSourceId, sourceId } = props;
    return (typeof catalogSourceId === 'string' &&
        catalogSourceId.length > 0 &&
        catalogSourceId === sourceId);
}
